module.exports = __webpack_public_path__ + "dist/img/qinghua.046670a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/content/qinghua.png
// module id = xM4M
// module chunks = 1